module.exports = __webpack_public_path__ + "layers-2x.png?4f0283c6ce28e888000e978e537a6a56";


//////////////////
// WEBPACK FOOTER
// ./~/leaflet/dist/images/layers-2x.png
// module id = 945
// module chunks = 2